import axios from "axios";

/**
 * Automatically set baseURL depending on environment
 * - Development: Proxy ("/dashboard/") to avoid CORS issues
 * - Production: Use the full API URL
 */
const api = axios.create({
  baseURL: "https://api.mysite.co.id/dashboard/", // Production API endpoint
  timeout: 10000, // 10 seconds timeout
  headers: {
    "Content-Type": "application/x-www-form-urlencoded", // Required for PHP $_POST
  },
  withCredentials: true, // Needed for cookies (JWT)
  validateStatus: (status) => true,
});

const apiSlow = axios.create({
  baseURL: "https://api.mysite.co.id/dashboard/", // Production API endpoint
  timeout: 10000 * 6, // 60 seconds timeout
  headers: {
    "Content-Type": "application/x-www-form-urlencoded", // Required for PHP $_POST
  },
  withCredentials: true, // Needed for cookies (JWT)
});

/**
 * Helper function to convert a JS object into URLSearchParams
 */
function toFormData(data) {
  const params = new URLSearchParams();
  Object.keys(data).forEach((key) => params.append(key, data[key]));
  return params;
}

/**
 * Public POST request (no authentication needed)
 * For endpoints like login.php or register.php
 */
export async function apiPostPublic(endpoint, data = {}) {
  try {
    const response = await api.post(endpoint, toFormData(data), { withCredentials: true });
    return response.data;
  } catch (error) {
    //throw error;
  }
}

/**
 * Authenticated POST request (requires valid auth_token cookie)
 * For shielded endpoints like dashboardInit.php or getData.php
 */
export async function apiPostAuth(endpoint, data = {}) {
  try {
    const response = await api.post(endpoint, toFormData(data), { withCredentials: true });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      if (window.location.pathname.startsWith("/dashboard")) {
        window.location.href = "/login";
      }
    }
    throw error;
  }
}

export async function apiPostAuthSlow(endpoint, data = {}) {
  try {
    const response = await apiSlow.post(endpoint, toFormData(data), { withCredentials: true });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      if (window.location.pathname.startsWith("/dashboard")) {
        window.location.href = "/login";
      }
    }
    //throw error;
  }
}

/**
 * GET request (works for both public and authenticated endpoints)
 * @param {string} endpoint - e.g., "auth_check.php"
 * @param {object} params - Query parameters
 * @param {boolean} requireAuth - If true, sends cookies
 */
export async function apiGet(endpoint, params = {}, requireAuth = false) {
  try {
    const response = await api.get(endpoint, {
      params,
      withCredentials: requireAuth,
    });
    return response.data;
  } catch (error) {
    if (requireAuth && error.response && error.response.status === 401) {
      if (window.location.pathname.startsWith("/dashboard")) {
        window.location.href = "/login";
      }
    }
    //throw error;
  }
}
